import {UserFragment} from "../gql/__codegen__/react-query";

export const getUserNameShort = (user: UserFragment) => user.user_profile ?
    user.user_profile.last_name + ', ' + user.user_profile.first_name?.charAt(0).toUpperCase() + '.'
    : user.displayName

export const getUserName = (user: UserFragment) => user.user_profile ?
    user.user_profile.first_name + ' ' + user.user_profile.last_name : user.displayName